// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-link-box{margin-bottom:34px}.app-link-box h3{line-height:normal!important}", ""]);
// Exports
module.exports = exports;
